import { MedProductType } from "src/utils/constants";
import { registerHandler } from "../handler";

declare const gtag: any;

const conversionIdMap = {
  [MedProductType.GLP1]: "AW-783925782/lLseCMSWmNAZEJaE5_UC",
  [MedProductType.Orals]: "AW-783925782/oPh3CPHVuO0ZEJaE5_UC",
  [MedProductType.HRT]: "AW-783925782/jrWhCKyTr7UaEJaE5_UC",
};

export default function registerHandlers() {
  registerHandler("lead", () => {
    gtag("event", "conversion", {
      send_to: "AW-783925782/tDBSCM2Kq4sBEJaE5_UC",
      value: 1.0,
      currency: "USD",
    });
  });

  registerHandler("purchase", ({ order }) => {
    gtag("event", "conversion", {
      send_to: "AW-783925782/XdY_CJWPuYsBEJaE5_UC",
      value: order.eltv_13_months,
      currency: "USD",
    });
  });

  registerHandler(
    "purchaseIntent",
    ({ plan, estimatedValue, medProductType }) => {
      const conversionId = conversionIdMap[medProductType];
      if (conversionId) {
        gtag("event", "conversion", {
          send_to: conversionId,
          value: estimatedValue || plan.plan_price,
          currency: "USD",
        });
      }
    }
  );

  registerHandler("noomPremium", ({ signupEltv13, products }) => {
    gtag("event", "conversion", {
      send_to: "AW-783925782/lGX8COvKsIQYEJaE5_UC",
      value: signupEltv13 + 40,
      products,
      currency: "USD",
    });
  });

  registerHandler("noomSummit", ({ signupEltv13, products }) => {
    gtag("event", "conversion", {
      send_to: "AW-783925782/Yp4oCOjKsIQYEJaE5_UC",
      value: signupEltv13 + 300,
      products,
      currency: "USD",
    });
  });
}
